import './App.css';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import AuthProvider from "./provider/authProvider";
import Routes from "./Routes/Index";

function App() {

  return (
    <div>
      <AuthProvider>
        <Routes />
      </AuthProvider>
      <ToastContainer />
    </div>

  );
}

export default App;

